// extracted by mini-css-extract-plugin
module.exports = {"error-container":"df5dab2e92--error-container--yX0D5","mobile":"df5dab2e92--mobile--YTIbm"};